import { connect } from 'react-redux';
import React from 'react';
import * as selectors from 'app/selectors';
import { FIX_LOCATION } from 'app/constants/hint';
import LocationRoleUsersForm from './LocationRoleUsersForm';

function LocationSettingManageForm({ manager, operators, updateLocation, users }) {
  const hint = FIX_LOCATION;
  const fields = [
    {
      name: 'manager_id',
      role: 'location_manager',
      range: 'all',
      title: '负责人',
      multi: false,
      selectedUsers: manager
    },
    {
      name: 'operator_ids',
      role: 'location_operator',
      range: 'all',
      title: '单楼栋运营',
      hint: hint.staff,
      selectedUsers: operators,
      requiredMessage: '请选择至少一位运营成员'
    }
  ];

  return (
    <div>
      <p style={{ color: '#c8c8c8', fontSize: 12, marginBottom: 20 }}>
        {hint.manage_team}
      </p>
      <LocationRoleUsersForm fields={fields} updateLocation={updateLocation} users={users} />
    </div>
  );
}

function mapStateToProps(state, props) {
  const { loc_id } = props;
  const operators = selectors.getTeamRolesOfLocation(
    state,
    loc_id,
    'location_operator'
  );

  const manager = selectors.getTeamRolesOfLocation(
    state,
    loc_id,
    'location_manager'
  );

  return {
    operators,
    manager,
    users: selectors.getSpaceUsers(state),
    updateLocation: props.updateLocation
  };
}

export default connect(mapStateToProps)(LocationSettingManageForm);
